'use strict';

var slim = require('@blockprotocol/type-system/slim');
var core = require('@blockprotocol/core');

const isEntityRecordId$1 = (recordId) => {
    return (recordId != null &&
        typeof recordId === "object" &&
        "entityId" in recordId &&
        "editionId" in recordId);
};

const isFileAtUrlData$1 = (fileData) => "url" in fileData;
const isFileData$1 = (fileData) => "file" in fileData;

const isOntologyTypeRecordId$1 = (recordId) => {
    return (recordId != null &&
        typeof recordId === "object" &&
        "baseUrl" in recordId &&
        typeof recordId.baseUrl === "string" &&
        slim.validateBaseUrl(recordId.baseUrl).type === "Ok" &&
        "version" in recordId &&
        typeof recordId.version === "number");
};

const ONTOLOGY_EDGE_KINDS = [
    "INHERITS_FROM",
    "CONSTRAINS_VALUES_ON",
    "CONSTRAINS_PROPERTIES_ON",
    "CONSTRAINS_LINKS_ON",
    "CONSTRAINS_LINK_DESTINATIONS_ON",
];
const KNOWLEDGE_GRAPH_EDGE_KIND = [
    "HAS_LEFT_ENTITY",
    "HAS_RIGHT_ENTITY",
];
const SHARED_EDGE_KIND = ["IS_OF_TYPE"];
// -------------------------------- Type Guards --------------------------------
const isOntologyEdgeKind$1 = (kind) => {
    return ONTOLOGY_EDGE_KINDS.includes(kind);
};
const isKnowledgeGraphEdgeKind$1 = (kind) => {
    return KNOWLEDGE_GRAPH_EDGE_KIND.includes(kind);
};
const isSharedEdgeKind$1 = (kind) => {
    return SHARED_EDGE_KIND.includes(kind);
};

// -------------------------------- Type Guards --------------------------------
const isOntologyOutwardEdge$1 = (edge) => {
    return (isOntologyEdgeKind$1(edge.kind) ||
        (isSharedEdgeKind$1(edge.kind) && isEntityRecordId$1(edge.rightEndpoint)));
};
const isKnowledgeGraphOutwardEdge$1 = (edge) => {
    return (isKnowledgeGraphEdgeKind$1(edge.kind) ||
        (isSharedEdgeKind$1(edge.kind) && isOntologyTypeRecordId$1(edge.rightEndpoint)));
};

const isOutgoingLinkEdge$1 = (outwardEdge) => {
    return outwardEdge.kind === "HAS_LEFT_ENTITY" && outwardEdge.reversed;
};
const isHasLeftEntityEdge$1 = (outwardEdge) => {
    return outwardEdge.kind === "HAS_LEFT_ENTITY" && !outwardEdge.reversed;
};
const isHasRightEntityEdge$1 = (outwardEdge) => {
    return outwardEdge.kind === "HAS_RIGHT_ENTITY" && !outwardEdge.reversed;
};
const isIncomingLinkEdge$1 = (outwardEdge) => {
    return outwardEdge.kind === "HAS_RIGHT_ENTITY" && outwardEdge.reversed;
};
const isIsOfTypeEdge$1 = (outwardEdge) => {
    return outwardEdge.kind === "IS_OF_TYPE" && !outwardEdge.reversed;
};

const isInheritsFromEdge$1 = (outwardEdge) => {
    return outwardEdge.kind === "INHERITS_FROM" && !outwardEdge.reversed;
};
const isIsInheritedByEdge$1 = (outwardEdge) => {
    return outwardEdge.kind === "INHERITS_FROM" && outwardEdge.reversed;
};
const isConstrainsValuesOnEdge$1 = (outwardEdge) => {
    return outwardEdge.kind === "CONSTRAINS_VALUES_ON" && !outwardEdge.reversed;
};
const isValuesConstrainedByEdge$1 = (outwardEdge) => {
    return outwardEdge.kind === "CONSTRAINS_VALUES_ON" && outwardEdge.reversed;
};
const isConstrainsPropertiesOnEdge$1 = (outwardEdge) => {
    return (outwardEdge.kind === "CONSTRAINS_PROPERTIES_ON" && !outwardEdge.reversed);
};
const isPropertiesConstrainedByEdge$1 = (outwardEdge) => {
    return (outwardEdge.kind === "CONSTRAINS_PROPERTIES_ON" && outwardEdge.reversed);
};
const isConstrainsLinksOnEdge$1 = (outwardEdge) => {
    return outwardEdge.kind === "CONSTRAINS_LINKS_ON" && !outwardEdge.reversed;
};
const isLinksConstrainedByEdge$1 = (outwardEdge) => {
    return outwardEdge.kind === "CONSTRAINS_LINKS_ON" && outwardEdge.reversed;
};
const isConstrainsLinkDestinationsOnEdge$1 = (outwardEdge) => {
    return (outwardEdge.kind === "CONSTRAINS_LINK_DESTINATIONS_ON" &&
        !outwardEdge.reversed);
};
const isLinkDestinationsConstrainedByEdge$1 = (outwardEdge) => {
    return (outwardEdge.kind === "CONSTRAINS_LINK_DESTINATIONS_ON" &&
        outwardEdge.reversed);
};
const isIsTypeOfEdge$1 = (outwardEdge) => {
    return outwardEdge.kind === "IS_OF_TYPE" && outwardEdge.reversed;
};

// @todo deduplicate this and libs/mock-block-dock/src/util.ts
/**
 * Checks if a given string is exactly a non-negative integer.
 *
 * For example, it will accept strings such as:
 * - "0"
 * - "1"
 * - "94818981"
 *
 * And it will not accept strings such as:
 * - "0.0"
 * - "1.0"
 * - "-1"
 * - "foo"
 * - "0foo"
 * - "1.1"
 *
 * @param {string} input
 */
const stringIsNonNegativeInteger = (input) => {
    const asInteger = Number.parseInt(input, 10);
    return asInteger.toString() === input && asInteger >= 0;
};

const isDataTypeVertex$1 = (vertex) => {
    return vertex.kind === "dataType";
};
const isPropertyTypeVertex$1 = (vertex) => {
    return vertex.kind === "propertyType";
};
const isEntityTypeVertex$1 = (vertex) => {
    return vertex.kind === "entityType";
};
const isEntityVertex$1 = (vertex) => {
    return vertex.kind === "entity";
};
const isOntologyTypeVertexId$1 = (vertexId) => {
    return (vertexId != null &&
        typeof vertexId === "object" &&
        "baseId" in vertexId &&
        typeof vertexId.baseId === "string" &&
        slim.validateBaseUrl(vertexId.baseId).type === "Ok" &&
        "revisionId" in vertexId &&
        typeof vertexId.revisionId === "string" &&
        stringIsNonNegativeInteger(vertexId.revisionId));
};
const isEntityVertexId$1 = (vertexId) => {
    return (vertexId != null &&
        typeof vertexId === "object" &&
        "baseId" in vertexId &&
        "revisionId" in vertexId &&
        /** @todo - is it fine to just check that versionId is string, maybe timestamp if we want to lock it into being a
         *    timestamp?
         */
        !isOntologyTypeVertexId$1(vertexId));
};

/**
 * Creates a handler for the graph module for the block.
 * Register callbacks in the constructor or afterwards using the 'on' method to react to messages from the embedder.
 * Call the relevant methods to send messages to the embedder.
 */
class GraphBlockHandler extends core.ModuleHandler {
    constructor({ callbacks, element, }) {
        super({ element, callbacks, moduleName: "graph", sourceType: "block" });
    }
    getInitPayload() {
        // there are no block messages which are sentOnInitialization in the graph module
        return {};
    }
    /**
     * Registers multiple callbacks at once.
     * Useful for bulk updates to callbacks after the module is first initialised.
     */
    registerCallbacks(callbacks) {
        super.registerCallbacks(callbacks);
    }
    /**
     * Removes multiple callbacks at once.
     * Useful when replacing previously registered callbacks
     */
    removeCallbacks(callbacks) {
        super.removeCallbacks(callbacks);
    }
    /**
     * Call the provided function when the named message is received, passing the data/errors object from the message.
     * If the named message expects a response, the callback should provide the expected data/errors object as the return.
     * @param messageName the message name to listen for
     * @param handlerFunction the function to call when the message is received, with the message data / errors
     */
    on(messageName, handlerFunction) {
        // @todo restore this when module resolution issue resolved
        // @see https://app.asana.com/0/1202542409311090/1202614421149286/f
        // const expectedMessageSource = "embedder";
        // const messageJsonDefinition = graphModuleJson.messages.find(
        //   (message) =>
        //     message.messageName === messageName &&
        //     message.source === expectedMessageSource,
        // );
        // if (!messageJsonDefinition) {
        //   throw new Error(
        //     `No message with name '${messageName}' expected from ${expectedMessageSource}.`,
        //   );
        // }
        this.registerCallback({
            callback: handlerFunction,
            messageName,
        });
    }
    // @todo automate creation of these methods from graph-module.json and types.ts
    createEntity({ data }) {
        return this.sendMessage({
            message: {
                messageName: "createEntity",
                data,
            },
            respondedToBy: "createEntityResponse", // @todo get these from graph-module.json
        });
    }
    updateEntity({ data }) {
        return this.sendMessage({
            message: {
                messageName: "updateEntity",
                data,
            },
            respondedToBy: "updateEntityResponse",
        });
    }
    deleteEntity({ data }) {
        // @todo fix this 'any'
        return this.sendMessage({
            message: {
                messageName: "deleteEntity",
                data,
            },
            respondedToBy: "deleteEntityResponse",
        });
    }
    getEntity({ data }) {
        return this.sendMessage({
            message: {
                messageName: "getEntity",
                data,
            },
            respondedToBy: "getEntityResponse",
        });
    }
    queryEntities({ data }) {
        return this.sendMessage({
            message: {
                messageName: "queryEntities",
                data,
            },
            respondedToBy: "queryEntitiesResponse",
        });
    }
    /** @todo - Add Type System mutation methods */
    // createEntityType({ data }: { data?: CreateEntityTypeData }) {
    //   return this.sendMessage<EntityType, CreateResourceError>({
    //     message: {
    //       messageName: "createEntityType",
    //       data,
    //     },
    //     respondedToBy: "createEntityTypeResponse", // @todo get this from graph-module.json
    //   });
    // }
    //
    // updateEntityType({ data }: { data?: UpdateEntityTypeData }) {
    //   return this.sendMessage<EntityType, ReadOrModifyResourceError>({
    //     message: {
    //       messageName: "updateEntityType",
    //       data,
    //     },
    //     respondedToBy: "updateEntityTypeResponse",
    //   });
    // }
    //
    // deleteEntityType({ data }: { data?: DeleteEntityTypeData }) {
    //   // @todo fix this 'any'
    //   return this.sendMessage<any, ReadOrModifyResourceError>({
    //     message: {
    //       messageName: "deleteEntityType",
    //       data,
    //     },
    //     respondedToBy: "deleteEntityTypeResponse",
    //   });
    // }
    getEntityType({ data }) {
        return this.sendMessage({
            message: {
                messageName: "getEntityType",
                data,
            },
            respondedToBy: "getEntityTypeResponse",
        });
    }
    queryEntityTypes({ data }) {
        return this.sendMessage({
            message: {
                messageName: "queryEntityTypes",
                data,
            },
            respondedToBy: "queryEntityTypesResponse",
        });
    }
    /** @todo - Reimplement linked queries */
    // createLinkedQuery({ data }: { data?: CreateLinkedQueryData }) {
    //   return this.sendMessage<LinkedQuery, CreateResourceError>({
    //     message: {
    //       messageName: "createLinkedQuery",
    //       data,
    //     },
    //     respondedToBy: "createLinkedQueryResponse",
    //   });
    // }
    //
    // updateLinkedQuery({ data }: { data?: UpdateLinkedQueryData }) {
    //   return this.sendMessage<LinkedQuery, ReadOrModifyResourceError>({
    //     message: {
    //       messageName: "updateLinkedQuery",
    //       data,
    //     },
    //     respondedToBy: "updateLinkedQueryResponse",
    //   });
    // }
    //
    // deleteLinkedQuery({ data }: { data?: DeleteLinkedQueryData }) {
    //   // @todo fix this 'any'
    //   return this.sendMessage<any, ReadOrModifyResourceError>({
    //     message: {
    //       messageName: "deleteLinkedQuery",
    //       data,
    //     },
    //     respondedToBy: "deleteLinkedQueryResponse",
    //   });
    // }
    //
    // getLinkedQuery({ data }: { data?: GetLinkedQueryData }) {
    //   return this.sendMessage<LinkedQuery, ReadOrModifyResourceError>({
    //     message: {
    //       messageName: "getLinkedQuery",
    //       data,
    //     },
    //     respondedToBy: "getLinkedQueryResponse",
    //   });
    // }
    uploadFile({ data }) {
        return this.sendMessage({
            message: {
                messageName: "uploadFile",
                data,
            },
            respondedToBy: "uploadFileResponse",
        });
    }
}

/**
 * Creates a handler for the graph module for the embedder.
 * Register callbacks in the constructor or afterwards using the 'on' method to react to messages from the block.
 * Call the relevant methods to send messages to the block.
 */
class GraphEmbedderHandler extends core.ModuleHandler {
    constructor({ blockEntitySubgraph, callbacks, element, 
    // linkedQueries,
    readonly, }) {
        super({ element, callbacks, moduleName: "graph", sourceType: "embedder" });
        this._blockEntitySubgraph = blockEntitySubgraph;
        // this._linkedQueries = linkedQueries;
        this._readonly = readonly;
    }
    /**
     * Registers multiple callbacks at once.
     * Useful for bulk updates to callbacks after the module is first initialised.
     */
    registerCallbacks(callbacks) {
        super.registerCallbacks(callbacks);
    }
    /**
     * Removes multiple callbacks at once.
     * Useful when replacing previously registered callbacks
     */
    removeCallbacks(callbacks) {
        super.removeCallbacks(callbacks);
    }
    /**
     * Call the provided function when the named message is received, passing the data/errors object from the message.
     * If the named message expects a response, the callback should provide the expected data/errors object as the return.
     * @param messageName the message name to listen for
     * @param handlerFunction the function to call when the message is received, with the message data / errors
     */
    on(messageName, handlerFunction) {
        // @todo restore this when module resolution issue resolved
        // @see https://app.asana.com/0/1202542409311090/1202614421149286/f
        // const expectedMessageSource = "block";
        // const messageJsonDefinition = graphModuleJson.messages.find(
        //   (message) =>
        //     message.messageName === messageName &&
        //     message.source === expectedMessageSource,
        // );
        // if (!messageJsonDefinition) {
        //   throw new Error(
        //     `No message with name '${messageName}' expected from ${expectedMessageSource}.`,
        //   );
        // }
        this.registerCallback({
            callback: handlerFunction,
            messageName,
        });
    }
    getInitPayload() {
        return {
            blockEntitySubgraph: this._blockEntitySubgraph,
            // linkedQueries: this._linkedQueries,
            readonly: this._readonly,
        };
    }
    blockEntitySubgraph({ data }) {
        if (!data) {
            throw new Error("'data' must be provided with blockEntitySubgraph");
        }
        this._blockEntitySubgraph = data;
        this.sendMessage({
            message: {
                messageName: "blockEntitySubgraph",
                data: this._blockEntitySubgraph,
            },
        });
    }
    // linkedQueries({ data }: { data?: LinkedQueries }) {
    //   this._linkedQueries = data;
    //   this.sendMessage({
    //     message: {
    //       messageName: "linkedQueries",
    //       data: this._linkedQueries,
    //     },
    //   });
    // }
    readonly({ data }) {
        this._readonly = data;
        this.sendMessage({
            message: {
                messageName: "readonly",
                data: this._readonly,
            },
        });
    }
}

/**
 * Defines the main entrypoint to the Block Protocol Graph Module package, without support for temporal versioning.
 * This defines the main types and type-guards used when working with the Graph module.
 *
 * Some commented out imports, and exports, are consciously left in the file as a quick indicator of what exports are
 * different from the entrypoint of the package _with_ temporal support.
 */
const isEntityRecordId = isEntityRecordId$1;
const isFileAtUrlData = isFileAtUrlData$1;
const isFileData = isFileData$1;
const isOntologyTypeRecordId = isOntologyTypeRecordId$1;
const isOntologyEdgeKind = isOntologyEdgeKind$1;
const isKnowledgeGraphEdgeKind = isKnowledgeGraphEdgeKind$1;
const isSharedEdgeKind = isSharedEdgeKind$1;
const isOntologyOutwardEdge = isOntologyOutwardEdge$1;
const isKnowledgeGraphOutwardEdge = isKnowledgeGraphOutwardEdge$1;
const isOutgoingLinkEdge = isOutgoingLinkEdge$1;
const isHasLeftEntityEdge = isHasLeftEntityEdge$1;
const isHasRightEntityEdge = isHasRightEntityEdge$1;
const isIncomingLinkEdge = isIncomingLinkEdge$1;
const isIsOfTypeEdge = isIsOfTypeEdge$1;
const isInheritsFromEdge = isInheritsFromEdge$1;
const isIsInheritedByEdge = isIsInheritedByEdge$1;
const isConstrainsValuesOnEdge = isConstrainsValuesOnEdge$1;
const isValuesConstrainedByEdge = isValuesConstrainedByEdge$1;
const isConstrainsPropertiesOnEdge = isConstrainsPropertiesOnEdge$1;
const isPropertiesConstrainedByEdge = isPropertiesConstrainedByEdge$1;
const isConstrainsLinksOnEdge = isConstrainsLinksOnEdge$1;
const isLinksConstrainedByEdge = isLinksConstrainedByEdge$1;
const isConstrainsLinkDestinationsOnEdge = isConstrainsLinkDestinationsOnEdge$1;
const isLinkDestinationsConstrainedByEdge = isLinkDestinationsConstrainedByEdge$1;
const isIsTypeOfEdge = isIsTypeOfEdge$1;
const isDataTypeVertex = isDataTypeVertex$1;
const isPropertyTypeVertex = isPropertyTypeVertex$1;
const isEntityTypeVertex = isEntityTypeVertex$1;
const isEntityVertex = (isEntityVertex$1);
const isOntologyTypeVertexId = isOntologyTypeVertexId$1;
const isEntityVertexId = isEntityVertexId$1;
// export type TemporalAxis = TemporalAxisGeneral;
// export type LimitedTemporalBound = LimitedTemporalBoundGeneral;
// export type InclusiveLimitedTemporalBound =
//   InclusiveLimitedTemporalBoundGeneral;
// export type ExclusiveLimitedTemporalBound =
//   ExclusiveLimitedTemporalBoundGeneral;
// export type Unbounded = UnboundedGeneral;
// export type TemporalBound = TemporalBoundGeneral;
// export type TimeIntervalUnresolved = TimeIntervalUnresolvedGeneral;
// export type TimeInterval = TimeIntervalGeneral;
// export type BoundedTimeInterval = BoundedTimeIntervalGeneral;
// export type VariableTemporalAxisUnresolved =
//   VariableTemporalAxisUnresolvedGeneral;
// export type VariableTemporalAxis = VariableTemporalAxisGeneral;
// export type PinnedTemporalAxisUnresolved = PinnedTemporalAxisUnresolvedGeneral;
// export type PinnedTemporalAxis = PinnedTemporalAxisGeneral;

Object.defineProperty(exports, 'DATA_TYPE_META_SCHEMA', {
    enumerable: true,
    get: function () { return slim.DATA_TYPE_META_SCHEMA; }
});
Object.defineProperty(exports, 'ENTITY_TYPE_META_SCHEMA', {
    enumerable: true,
    get: function () { return slim.ENTITY_TYPE_META_SCHEMA; }
});
Object.defineProperty(exports, 'PROPERTY_TYPE_META_SCHEMA', {
    enumerable: true,
    get: function () { return slim.PROPERTY_TYPE_META_SCHEMA; }
});
Object.defineProperty(exports, 'extractBaseUrl', {
    enumerable: true,
    get: function () { return slim.extractBaseUrl; }
});
Object.defineProperty(exports, 'extractVersion', {
    enumerable: true,
    get: function () { return slim.extractVersion; }
});
Object.defineProperty(exports, 'getReferencedIdsFromEntityType', {
    enumerable: true,
    get: function () { return slim.getReferencedIdsFromEntityType; }
});
Object.defineProperty(exports, 'getReferencedIdsFromPropertyType', {
    enumerable: true,
    get: function () { return slim.getReferencedIdsFromPropertyType; }
});
Object.defineProperty(exports, 'isPropertyValuesArray', {
    enumerable: true,
    get: function () { return slim.isPropertyValuesArray; }
});
Object.defineProperty(exports, 'validateBaseUrl', {
    enumerable: true,
    get: function () { return slim.validateBaseUrl; }
});
Object.defineProperty(exports, 'validateVersionedUrl', {
    enumerable: true,
    get: function () { return slim.validateVersionedUrl; }
});
exports.GraphBlockHandler = GraphBlockHandler;
exports.GraphEmbedderHandler = GraphEmbedderHandler;
exports.isConstrainsLinkDestinationsOnEdge = isConstrainsLinkDestinationsOnEdge;
exports.isConstrainsLinksOnEdge = isConstrainsLinksOnEdge;
exports.isConstrainsPropertiesOnEdge = isConstrainsPropertiesOnEdge;
exports.isConstrainsValuesOnEdge = isConstrainsValuesOnEdge;
exports.isDataTypeVertex = isDataTypeVertex;
exports.isEntityRecordId = isEntityRecordId;
exports.isEntityTypeVertex = isEntityTypeVertex;
exports.isEntityVertex = isEntityVertex;
exports.isEntityVertexId = isEntityVertexId;
exports.isFileAtUrlData = isFileAtUrlData;
exports.isFileData = isFileData;
exports.isHasLeftEntityEdge = isHasLeftEntityEdge;
exports.isHasRightEntityEdge = isHasRightEntityEdge;
exports.isIncomingLinkEdge = isIncomingLinkEdge;
exports.isInheritsFromEdge = isInheritsFromEdge;
exports.isIsInheritedByEdge = isIsInheritedByEdge;
exports.isIsOfTypeEdge = isIsOfTypeEdge;
exports.isIsTypeOfEdge = isIsTypeOfEdge;
exports.isKnowledgeGraphEdgeKind = isKnowledgeGraphEdgeKind;
exports.isKnowledgeGraphOutwardEdge = isKnowledgeGraphOutwardEdge;
exports.isLinkDestinationsConstrainedByEdge = isLinkDestinationsConstrainedByEdge;
exports.isLinksConstrainedByEdge = isLinksConstrainedByEdge;
exports.isOntologyEdgeKind = isOntologyEdgeKind;
exports.isOntologyOutwardEdge = isOntologyOutwardEdge;
exports.isOntologyTypeRecordId = isOntologyTypeRecordId;
exports.isOntologyTypeVertexId = isOntologyTypeVertexId;
exports.isOutgoingLinkEdge = isOutgoingLinkEdge;
exports.isPropertiesConstrainedByEdge = isPropertiesConstrainedByEdge;
exports.isPropertyTypeVertex = isPropertyTypeVertex;
exports.isSharedEdgeKind = isSharedEdgeKind;
exports.isValuesConstrainedByEdge = isValuesConstrainedByEdge;
